import { getPendingMutations, removeMutation, updateMutationRetry } from './OfflineDb';
import ConnectivityService from './ConnectivityService';

let processing = false;

export async function processSyncQueue(): Promise<void> {
    if (processing || !ConnectivityService.isOnline) return;
    processing = true;

    try {
        const mutations = await getPendingMutations();
        if (mutations.length === 0) {
            processing = false;
            return;
        }

        console.log(`[SyncQueue] Processing ${mutations.length} pending mutations`);

        for (const mutation of mutations) {
            if (!ConnectivityService.isOnline) break;

            try {
                const fetchOptions: RequestInit = {
                    method: mutation.method,
                    credentials: 'include',
                };

                if (mutation.body && mutation.method !== 'GET') {
                    fetchOptions.headers = { 'Content-Type': 'application/json' };
                    fetchOptions.body = mutation.body;
                }

                const res = await fetch(mutation.url, fetchOptions);

                if (res.ok || res.status === 404) {
                    // Success or resource already gone — remove from queue
                    await removeMutation(mutation.id);
                    console.log(`[SyncQueue] Synced: ${mutation.type} (${mutation.id})`);
                } else if (res.status >= 400 && res.status < 500) {
                    // Client error — don't retry, remove
                    console.warn(`[SyncQueue] Client error ${res.status} for ${mutation.type}, removing`);
                    await removeMutation(mutation.id);
                } else {
                    // Server error — retry later
                    await updateMutationRetry(mutation.id, mutation.retryCount + 1);
                    console.warn(`[SyncQueue] Server error ${res.status} for ${mutation.type}, will retry`);
                }
            } catch (e) {
                // Network error — stop processing, retry later
                console.warn(`[SyncQueue] Network error for ${mutation.type}, stopping`, e);
                await updateMutationRetry(mutation.id, mutation.retryCount + 1);
                break;
            }
        }
    } finally {
        processing = false;
    }
}

export function startSyncQueueListener(): void {
    // Process on connectivity change
    ConnectivityService.subscribe((online) => {
        if (online) {
            console.log('[SyncQueue] Back online, processing queue...');
            setTimeout(() => processSyncQueue(), 2000);
        }
    });

    // Also try processing periodically
    setInterval(() => {
        if (ConnectivityService.isOnline) {
            processSyncQueue();
        }
    }, 60000);

    // Process any pending items on startup
    if (ConnectivityService.isOnline) {
        setTimeout(() => processSyncQueue(), 5000);
    }
}
